import { ReactNode, useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export interface SlotProps {
  id: string;
  children: ReactNode;
  className?: string;
}

const splitClasses = (className: string): string[] => className.split(/\s+/).filter(Boolean);

export const Slot = ({ id, children, className }: SlotProps) => {
  const [target, setTarget] = useState<HTMLElement | null>(null);

  useLayoutEffect(() => {
    const element = document.getElementById(id);
    if (!element) return;

    setTarget(element);

    if (className) {
      element.classList.add(...splitClasses(className));
    }

    return () => {
      setTarget(null);
      if (className) {
        element.classList.remove(...splitClasses(className));
      }
    };
  }, [id, className]);

  if (!target || !children) return null;

  return createPortal(children, target);
};
